import { APIClient } from '@frontend/api-utils';
import { AttachModule } from '@frontend/locker/types';

export class LockerAttachClient extends APIClient {
    public static readonly endpoint = '/locker-api/v1';

    public static async attachModule(accountId: string, iotId: string, deviceId: string, body: AttachModule): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/modules`, body);
        return this.handleVoidResponse(response);
    }
}
